import { useState } from 'react';
import { RouterProvider } from 'react-router';

import { router } from '../../../../router';

export const RouterWrapper = () => {
  const [routerInstance] = useState(router);

  return <RouterProvider router={routerInstance} />;
};
